<template>
  <modal
    v-model="show"
    max-width="700"
    content-class="access-point-controller-list"
    :has-padding="false"
  >
    <button class="btn btn-primary btn-extra-round" slot="activator">
      {{ $t("message.spots.message.controllers") }}
    </button>

    <div class="access-point-controller-list-body">
      <h1 class="text-center">
        {{ $t("message.spots.message.controllersRegistration") }}
      </h1>

      <access-point-controller-form
        @submit="load"
        @on-handle-list-show="handleListShow"
      />

      <v-data-table
        class="access-point-controller-list-body-table card-data-table"
        :headers="headers"
        :items="list"
        :loading="loading"
        :hide-actions="true"
        :no-data-text="$t('message.spots.message.noControllerRegistered')"
        :no-results-text="$t('message.generics.message.noData')"
      >
        <template slot="items" slot-scope="props">
          <access-point-controller-list-item
            :item="props.item"
            @edited="load"
            @deleted="load"
            @on-handle-list-show="handleListShow"
          />
        </template>
      </v-data-table>
    </div>
  </modal>
</template>

<script>
import AccessPointControllerForm from "@components/modules/access-point/controller/form/AccessPointControllerForm";
import AccessPointControllerListItem from "@components/modules/access-point/controller/list/item/AccessPointControllerListItem";
import Modal from "@/components/generic/Modal";

export default {
  components: {
    AccessPointControllerForm,
    AccessPointControllerListItem,
    Modal,
  },

  data() {
    return {
      loading: false,
      show: false,
      list: [],
    };
  },

  mounted() {
    this.load();
  },

  props: {},

  computed: {
    headers() {
      return [
        {
          text: this.$t("message.generics.message.name"),
          value: "name",
          sortable: false,
        },
        {
          text: "Tipo",
          value: "type",
          sortable: false,
        },
        {
          text: this.$t("message.admGenerics.message.edition"),
          value: "",
          sortable: false,
          width: 100,
        },
      ];
    },
  },

  methods: {
    handleListShow() {
      this.show = !this.show;
    },
    async load() {
      this.loading = true;

      const list = await this.$api.core.accessPoint.controller.list();

      this.list = list;

      this.$store.commit("LOCALS_SET_CONTROLLERS_LIST", this.list);

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.access-point-controller-list {
  .access-point-controller-list-body {
    padding: 30px 20px 50px;
  }
}
</style>
